module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.fa11626.ttf";